<template>
<a
  :href='card.link'
  :style="{backgroundImage: `url('${card.image}')`}"
  class='self-assessment-results_hero-card'
  target='_blank'
>
  <div
    v-if='card.title'
    class='self-assessment-results_hero-card_inner'
  >
    <div class='self-assessment-results_hero-card_title heading-four'>
      {{ card.title }}
    </div>

    <div
      v-if='card.subtitle'
      class='self-assessment-results_hero-card_subtitle heading-six'
    >
      <CertIcon v-if="card.badging_enabled" />
      {{ card.subtitle }}
    </div>
  </div>
</a>
</template>

<script>
import CertIcon from './cert.svg'

export default {
  props: ['card'],

  components: {
    CertIcon
  }
}
</script>

<style lang='sass' scoped>
  @import './HeroCard'
</style>
